import React, { Fragment } from 'react';
import { ArcaHttpClientPageDetails } from '../../../code/ArcaHttpClientPageDetails.js';
import { ArcaComponent } from '../../pages/ArcaComponent.js';
import { PageDetails } from './PageDetails.jsx';

export class Equipment extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            pageListDetails: null
        };
    }

    componentDidMount() {
        ArcaHttpClientPageDetails.GetListAsync('Main',
            (details => this.setState({ details: details })));
    }

    render() {
        const { details } = this.state;

        return (
            <Fragment>
                {details ?
                    <PageDetails pageListDetails={details?.filter(x => x.Title.includes('equipment'))} />
                    : null}
            </Fragment>

        );
    }
}
